exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2DT4g{color:#7f46ca;font-weight:600;font-size:14px;padding:2px 0}._1ikT5,._3nFg1{width:42px;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:rgba(127,70,202,.1);border-radius:2px}._1ikT5{width:auto}._3nFg1>svg{width:20px;height:20px}._1ikT5>svg,._2GexU>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"root": "_2DT4g",
	"iconWithText": "_1ikT5",
	"iconType": "_3nFg1",
	"textType": "_2GexU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Elements/IsGuaranteedElement/IsGuaranteedElement.css
// module id = 2330
// module chunks = 15 17 32